import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// tslint:disable-next-line:max-line-length
import { DialogShowSelectedImageFromFileComponent } from './dialog-show-selected-image-from-file/dialog-show-selected-image-from-file.component';
import {SearchComponent} from './search/search.component';
import {ResultsComponent} from './results/results.component';
import {LoadingSpinnerModule} from '../loading-spinner/loading-spinner.module';
import {HeaderModule} from '../header/header.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ImageGalleryModule} from '../image-gallery/image-gallery.module';
import {FlexLayoutModule} from '@angular/flex-layout';
import {BottomSheetGenericModule} from '../bottom-sheet-generic/bottom-sheet-generic.module';
import {MatIconModule} from '@angular/material/icon'; 
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner'; 
@NgModule({
  declarations: [SearchComponent, ResultsComponent, DialogShowSelectedImageFromFileComponent],
  imports: [
    CommonModule,
    MatTooltipModule,
    MatDialogModule,
    LoadingSpinnerModule,
    HeaderModule,
    FormsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatOptionModule,
    MatSelectModule,
    ImageGalleryModule,
    FlexLayoutModule,
    MatButtonModule,
    BottomSheetGenericModule,
    MatInputModule,
    MatIconModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule
  ],
  entryComponents: [DialogShowSelectedImageFromFileComponent]
})
export class SearchExternalApiModule { }
